import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import {
  IconAt,
  IconBoltFilled,
  IconFileInvoice,
  IconKey,
} from "@tabler/icons-react";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const SendLightning = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.SEND_LIGHTNING}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Send Lightning Payment"
            articleSlug={ARTICLES.SENDING_LIGHTNING_PAYMENTS.slug}
            icon={<IconBoltFilled size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <Button
            leftSection={<IconAt />}
            size="sm"
            variant="default"
            aria-label="pay to lightning address"
            onClick={() => cubby.setModal(MODALS.PAY_TO_LIGHTNING_ADDRESS)}
          >
            Pay To Lightning Address
          </Button>
          <Text>
            A lightning address looks like an email address, typically like{" "}
            <Text span c="blue">
              username@service.com
            </Text>
          </Text>
          <Divider my="xs" />
          <Button
            leftSection={<IconFileInvoice />}
            size="sm"
            variant="default"
            aria-label="pay to invoice"
            onClick={() => cubby.setModal(MODALS.SEND_VIA_BOLT_11_INVOICE)}
          >
            Pay To Invoice
          </Button>
          <Text>
            Paying to an invoice is the most reliable way to send a payment with
            the Lightning Network. These are "Bolt 11" invoices.
          </Text>
          <Divider my="xs" />
          <Button
            leftSection={<IconKey />}
            size="sm"
            variant="default"
            aria-label="keysend"
            onClick={() => cubby.setModal(MODALS.SEND_VIA_KEYSEND)}
          >
            Keysend Payment
          </Button>
          <Text>
            Keysend payments are experimental. You need a node's public key to
            send this.
          </Text>
        </Stack>
      </Modal>
    </>
  );
});

export default SendLightning;
